var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('IAmOverlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('BCard', [_c('b-nav', {
    attrs: {
      "pills": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "to": _vm.SYSTEM_CONFIGS_ROUTE_HASH.SYSTEM_CONFIGS,
      "active": _vm.$route.hash === _vm.SYSTEM_CONFIGS_ROUTE_HASH.SYSTEM_CONFIGS || _vm.$route.hash === ''
    }
  }, [_c('div', {
    staticClass: "d-flex-center"
  }, [_c('IAmIcon', {
    attrs: {
      "icon": "config",
      "size": "16"
    }
  }), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v(_vm._s(_vm.$t('myAccount.systemConfigs.title')))])], 1)]), _c('b-nav-item', {
    attrs: {
      "to": _vm.SYSTEM_CONFIGS_ROUTE_HASH.ERROR_MESSAGES,
      "active": _vm.$route.hash === _vm.SYSTEM_CONFIGS_ROUTE_HASH.ERROR_MESSAGES
    }
  }, [_c('div', {
    staticClass: "d-flex-center"
  }, [_c('IAmIcon', {
    attrs: {
      "icon": "infoCircleOutline",
      "size": "16"
    }
  }), _c('span', {
    staticClass: "d-none d-sm-inline"
  }, [_vm._v(_vm._s(_vm.$t('myAccount.systemConfigs.errorMessages.title')))])], 1)])], 1), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "p-0",
    class: ['tab-pane', {
      'active': _vm.$route.hash === _vm.SYSTEM_CONFIGS_ROUTE_HASH.SYSTEM_CONFIGS || _vm.$route.hash === ''
    }]
  }, [_c('i', [_vm._v("To do")])]), _c('div', {
    staticClass: "p-0",
    class: ['tab-pane', {
      'active': _vm.$route.hash === _vm.SYSTEM_CONFIGS_ROUTE_HASH.ERROR_MESSAGES
    }]
  }, [_c('ErrorMessagesConfigs')], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }